export const bookingBaseUrl = 'bestill-norgespakke-samme-dag'
export const oldBookingBaseUrl = 'bestill-norgespakke-dor-til-dor'
export const bookingDetailsUrl = 'detaljer'
export const bookingSummaryUrl = 'oppsummering'
export const bookingReceiptUrl = 'kvittering'
export const bookingFailureUrl = 'noe-gikk-galt'
